import { useCallback, useEffect, useState } from "react";
import { formatInputValue } from "../../../Utils/formatInputValue";
import { convertToCents, convertToUnity } from "../../../Utils/formatters";
import { Input } from "../../Atoms";
import { SelectOptionButtons } from "../SelectOptions";
import { CustomInput } from "./styles";

export const InputMoney = ({ hasInput = true, refreshValue = () => {} }) => {
  const [linkValue, setLinkValue] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const options = [
    {
      key: 1,
      title: "+ 1",
    },
    {
      key: 10,
      title: "+ 10",
    },
    {
      key: 50,
      title: "+ 50",
    },
    {
      key: 100,
      title: "+ 100",
    },
    {
      key: 0,
      title: "limpar",
    },
  ];

  useEffect(() => {
    const mq = window.matchMedia && window.matchMedia("(max-width: 480px)");
    const set = () => setIsMobile(mq?.matches ?? false);
    set();
    mq?.addEventListener?.("change", set);
    return () => mq?.removeEventListener?.("change", set);
  }, []);

  const visibleOptions = isMobile ? options.filter((o) => o.key !== 0) : options;

  const handleValue = useCallback(
    (e) => {
      let toSum = convertToCents(e);
      let value = convertToCents(linkValue);
      value = value + toSum;

      if (toSum === 0) {
        refreshValue(toSum);
        setLinkValue(formatInputValue("0"));
      } else {
        setLinkValue(formatInputValue(value.toString()));
        refreshValue(convertToUnity(value));
      }
    },
    [linkValue]
  );

  const handleCustomValue = useCallback(
    (e) => {
      let value = e;
      setLinkValue(formatInputValue(value.toString()));
    },
    [linkValue]
  );

  useEffect(() => {
    refreshValue(linkValue);
  }, [linkValue]);

  return hasInput ? (
    <div
      style={{
        padding: "0px 0px 20px 0px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div>
        <Input
          style={{ fontSize: 20, width: '100%' }}
          value={linkValue}
          
          onChange={(e) => {
            setLinkValue(formatInputValue(e.currentTarget.value));
          }}
          name="value"
          type="text"
          maxLength={10}
          placeholder="Valor (R$)"
          aria-label="amount-input"
        />
      </div>
      <div>
        <SelectOptionButtons
          columnsDesktop={5}
          columnsMobile={2}
          options={visibleOptions}
          refreshOptionSelected={(e) => handleValue(e)}
        />
      </div>
    </div>
  ) : (
    <>
      <CustomInput
        style={{ fontSize: 20, width: '100%' }}
        value={linkValue}
        onChange={(e) => {
          handleCustomValue(e.currentTarget.value);
        }}
        type="text"
        maxLength={10}
        placeholder="Valor (R$)"
      />
      <SelectOptionButtons
        columnsDesktop={5}
        columnsMobile={2}
        options={visibleOptions}
        refreshOptionSelected={(e) => handleValue(e)}
      />
    </>
  );
};
